export default __webpack_public_path__ + "static/media/product29_slides.ce138f0a.webp";